export default "__VITE_ASSET__D9MCww7w__"